import rootReducer from '../reducers'
import thunk from 'redux-thunk'
import { applyMiddleware, compose, createStore } from 'redux'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import createLogger from 'redux-logger'
import { persistStore, autoRehydrate } from 'redux-persist'
import { asyncSessionStorage } from 'redux-persist/storages'
import { REHYDRATE } from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer'

export default function configureStore(initialState) {
  let createStoreWithMiddleware
  const logger = createLogger()
  const browserMiddleware = routerMiddleware(browserHistory)
  let middleware
  if (process.env.NODE_ENV !== 'production') {
    middleware = applyMiddleware(
      thunk,
      logger,
      browserMiddleware,
      createActionBuffer(REHYDRATE)
    )
  } else {
    middleware = applyMiddleware(
      thunk,
      browserMiddleware,
      createActionBuffer(REHYDRATE)
    )
  }

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle, indent */
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // TODO Try to remove when `react-router-redux` is out of beta, LOCATION_CHANGE should not be fired more than once after hot reloading
          // Prevent recomputing reducers for `replaceReducer`
          shouldHotReload: false
        })
      : compose
  /* eslint-enable */

  createStoreWithMiddleware = composeEnhancers(autoRehydrate(), middleware)

  const store = createStoreWithMiddleware(createStore)(
    rootReducer,
    initialState
  )

  persistStore(store, { storage: asyncSessionStorage, blacklist: ['routing'] })

  return store
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js